<div class="obg-m-suspicious-login-content">
	<p>{{ "suspicious-login.info.verify" | translate }}</p>
	<mat-radio-group labelPosition="before" (change)="onSelectionChange($event)" [(ngModel)]="selectedChannel">
		<h3 matSubHeader>{{ "suspicious-login.title.send-code" | translate }}</h3>

		<ng-template ngFor let-method [ngForOf]="communicationMethods" let-index="index" [ngForTrackBy]="methodTrackBy">
			<mat-radio-button
				color="primary"
				[value]="method.channel"
				attr.test-id="suspicious-login-{{ method.channel }}"
			>
				{{ "suspicious-login.send-code.option." + method.channel | lowercase | translate }} {{ method.details }}
			</mat-radio-button>

			<mat-divider></mat-divider>
		</ng-template>

		<mat-radio-button color="primary" value="forgot-password" test-id="suspicious-login-reset-password">
			{{ "suspicious-login.send-code.option.forgot-password" | translate }}
		</mat-radio-button>

		<mat-divider></mat-divider>

		<mat-radio-button color="primary" value="has-code" test-id="suspicious-login-has-code">
			{{ "suspicious-login.send-code.option.have-code" | translate }}
		</mat-radio-button>
	</mat-radio-group>

	<p class="error" *ngIf="showErrorMessage">{{ "suspicious-login.send-code.fail" | translate }}</p>
</div>

<div class="obg-m-suspicious-login-actions">
	<button
		mat-flat-button
		color="accent"
		test-id="suspicious-login-send-code-btn"
		(click)="submit.emit(selectedChannel)"
		[disabled]="!selectedChannel"
		*ngIf="buttonText"
	>
		{{ buttonText | translate }}
	</button>

	<p [innerHtml]="'suspicious-login.footer' | translate"></p>
</div>
